module.exports = __webpack_public_path__ + "img/4_sp.e49beab2.gif";